var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmazonRoom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6429 4.79387H5.64288V18.7939H11.6429V4.79387ZM4.64288 3.79387V19.7939H12.6429V3.79387H4.64288Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6429 4.79387H12.6429V18.7939H18.6429V4.79387ZM11.6429 3.79387V19.7939H19.6429V3.79387H11.6429Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0405 16.5496H7.0405V15.5496H10.0405V16.5496Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1429 16.5496H14.1429V15.5496H17.1429V16.5496Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0405 14.0668H7.0405V13.0668H10.0405V14.0668Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1429 14.0668H14.1429V13.0668H17.1429V14.0668Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.54051 9.86508C7.56614 9.86508 7.58691 9.8443 7.58691 9.81867C7.58691 9.79304 7.56614 9.77227 7.54051 9.77227C7.51488 9.77227 7.4941 9.79304 7.4941 9.81867C7.4941 9.8443 7.51488 9.86508 7.54051 9.86508ZM6.58691 9.81867C6.58691 9.29202 7.01385 8.86508 7.54051 8.86508C8.06716 8.86508 8.4941 9.29202 8.4941 9.81867C8.4941 10.3453 8.06716 10.7723 7.54051 10.7723C7.01385 10.7723 6.58691 10.3453 6.58691 9.81867Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1893 9.86508C14.2149 9.86508 14.2357 9.8443 14.2357 9.81867C14.2357 9.79304 14.2149 9.77227 14.1893 9.77227C14.1636 9.77227 14.1429 9.79304 14.1429 9.81867C14.1429 9.8443 14.1636 9.86508 14.1893 9.86508ZM13.2357 9.81867C13.2357 9.29202 13.6626 8.86508 14.1893 8.86508C14.7159 8.86508 15.1429 9.29202 15.1429 9.81867C15.1429 10.3453 14.7159 10.7723 14.1893 10.7723C13.6626 10.7723 13.2357 10.3453 13.2357 9.81867Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonRoom);
export default __webpack_public_path__ + "static/media/amazon_room.6e8105099fc3337a6c3deddd099ba0d2.svg";
export { ForwardRef as ReactComponent };